
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageBase from "../PageBase.vue";
import { togglePages } from '@/components/utils/TogglePages';
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import * as _ from 'underscore';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import Tooltip from "@/components/survey/Tooltip.vue";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        PageBase,
        Tooltip
    }
})
export default class EnfrcQuestionnaire extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    @applicationState.State
    public rejectedPathway!: boolean;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void
    
    selectedEnforcementQuestionnaire = [];

    showLegalAssistance = false;
    showEnforceOrder = false;
    popInfo = false;
    popInfoUnderstand = '';    

    confirmedError = false;

    currentStep = 0;
    currentPage = 0;

    allPages = []; 

    mounted(){
        this.confirmedError = false
        this.allPages = _.range(this.stPgNo.ENFRC.EnforceAgreementOrOrder, Object.keys(this.stPgNo.ENFRC).length-1) 
        this.reloadPageInformation();
    }

    public reloadPageInformation() {

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        if (this.step.result?.enfrcQuestionnaireSurvey) {
            this.selectedEnforcementQuestionnaire = this.step.result.enfrcQuestionnaireSurvey.data;
        }

        this.setSteps(this.selectedEnforcementQuestionnaire, false);
        
        this.setProgress(false)
    }


    public onChange(selectedEnforcementQuestionnaire) {
        const p = this.stPgNo.ENFRC
        this.UpdatePathwayCompleted({pathway:"agreementEnfrc", isCompleted:false});
        togglePages([p.PreviewForm26ENFRC, p.PreviewForm27ENFRC, p.PreviewForm28ENFRC, p.PreviewForm29ENFRC], false, this.currentStep);
        
        if(this.checkErrorOnPages())        
            this.setSteps(selectedEnforcementQuestionnaire, true);
        else{ 
            this.selectedEnforcementQuestionnaire = [];             
        }
        Vue.filter('surveyChanged')('agreementEnfrc')        
    }

    public setSteps(selectedEnforcementQuestionnaire, surveyChanged) {

        const p = this.stPgNo.ENFRC
        if (selectedEnforcementQuestionnaire) {            
           
            this.setProgress(surveyChanged)

            if (selectedEnforcementQuestionnaire.length > 0){
                
                togglePages([p.AboutTheOrderEnforcement, p.ReviewYourAnswersENFRC],true, this.currentStep)
                togglePages([p.DetermineAnAmountOwingForExpenses], this.selectedEnforcementQuestionnaire.includes("expenses"), this.currentStep);
                togglePages([p.DetermineArrears], this.selectedEnforcementQuestionnaire.includes("arrears"), this.currentStep);
                togglePages([p.EnforceAgreementOrOrder], this.selectedEnforcementQuestionnaire.includes("writtenAgreementOrder"), this.currentStep);
                togglePages([p.EnforceChangeOrSetAsideDetermination], this.selectedEnforcementQuestionnaire.includes("parentingCoordinatorDetermination"), this.currentStep);    
                
                if(surveyChanged){
                    if(this.$store.state.Application.steps[this.currentStep].pages[p.EnforceAgreementOrOrder].progress==100)
                        Vue.filter('setSurveyProgress')(null, this.currentStep, p.EnforceAgreementOrOrder, 50, false);
                                    
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.EnforceChangeOrSetAsideDetermination, 0, false); 
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.DetermineAnAmountOwingForExpenses, 0, false);  
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.DetermineArrears, 0, false);         
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.AboutTheOrderEnforcement, 0, false);                            
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.ReviewYourAnswersENFRC, 0, false);
                }
                
            }else{
                togglePages(this.allPages, false, this.currentStep);  
                this.confirmedError = false
            }   

        }
    }  

    public checkErrorOnPages(){

        const optionalLabels = ["Next Steps", "Review and Print", "Review and Save", "Review and Submit"]
        for(const stepIndex of [this.stPgNo.COMMON._StepNo]){
            const step = this.$store.state.Application.steps[stepIndex]
            if(step.active){
                for(const page of step.pages){
                    if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                        togglePages(this.allPages, false, this.currentStep); 
                        this.$store.commit("Application/setCurrentStep", step.id);
                        this.$store.commit("Application/setCurrentStepPage", {currentStep: step.id, currentPage: page.key });                        
                        return false;
                    }
                }
            }            
        }
        return true;        
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        if (this.selectedEnforcementQuestionnaire.includes('foreignSupport')) {            
            this.popInfo = true;
        } else {
            Vue.prototype.$UpdateGotoNextStepPage();
        }
    }

    public closePopupConfirm(){
        this.popInfo = false;
        Vue.prototype.$UpdateGotoNextStepPage();            
    }

    public getselectedEnforcementQuestionnaireNames(){
        let result = ''       
        for(const form of this.selectedEnforcementQuestionnaire){
            if(form=='writtenAgreementOrder')   result+='-Enforce a written agreement or order'+'\n';
            if(form=='parentingCoordinatorDetermination')  result+='-Enforce, Change or Set Aside a Determination of a Parenting Coordinator'+'\n';
            if(form=='expenses')    result+='-Set an amount of money owing for expenses for failure to comply'+'\n';
            if(form=='arrears')         result+='-Determine if arrears are owing from a support order or agreement made under the Family Law Act and, if so, the amount of the arrears'+'\n';
            if(form=='foreignSupport')          result+='-Set aside the registration of a foreign support order'+'\n';
            
        }
        return result;
    }

    public setProgress(surveyChanged){
        
        const initProgress = this.step.pages[this.currentPage].progress
        
        let progress = this.selectedEnforcementQuestionnaire.length==0? 50 : 100;
  
        if(surveyChanged || initProgress != 100){           
                
            if (this.selectedEnforcementQuestionnaire?.includes('foreignSupport') && this.popInfoUnderstand != 'understand'){
                Vue.filter('surveyChanged')('agreementEnfrc')
                progress = 50
            }
        }

        if(progress == 50 && this.selectedEnforcementQuestionnaire.length>0){ 
            this.confirmedError = true
            Vue.filter('scrollToLocation')('next-error')
        }
        else
            this.confirmedError = false

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
    }
  
    beforeDestroy() {
        this.setProgress(false)
        const questions = [{name:'EnfrcQuestionnaire',title:'I want to apply for the following Enforcement options:',value:this.getselectedEnforcementQuestionnaireNames()}]        
        this.UpdateStepResultData({step:this.step, data: {enfrcQuestionnaireSurvey: {data: this.selectedEnforcementQuestionnaire, questions: questions, pageName:"Enforcement Questionnaire", currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
